import React, { useState, useEffect } from 'react';
import DOMPurify from 'dompurify';
import { translatedMessage } from '../../service/LanguageService';
import GeneralUtils from '../../utilities/GeneralUtils';
import CompetitionUtils from '../../utilities/CompetitionUtils';

const CompetitionNationalDetailsComponent = (props) => {
    const [competition, setCompetition] = useState(null);

    useEffect(() => {
        setCompetition(props.competition);
    }, [props]);

    DOMPurify.addHook('afterSanitizeAttributes', function (node) {
        // set all elements owning target to target=_blank
        if ('target' in node) {
            node.setAttribute('target', '_blank');
            node.setAttribute('rel', 'noopener');
        }
    });


    return (
        <>
            <div className='col-12 md:col-6'>
                <div className='filed-label'>{translatedMessage('competition.institution')}</div>
                <div className='filed-value'>{competition?.institution?.name ? competition?.institution.name : "-"}</div>
            </div>
            <div className="col-12 md:col-6">
                <div className="filed-label">{translatedMessage('generic.status')}</div>
                <div className="filed-value">
                    <span className={`w-min status status-competition-${competition?.status.toString().toLowerCase()}`}>
                        {CompetitionUtils.getCompetitionStatus(competition)}
                    </span>
                </div>
            </div>
            <div className="col-12 md:col-6">
                <div className="filed-label">{translatedMessage('competition.positionCategory')}</div>
                <div className="filed-value">
                    {translatedMessage("PositionCategory." + competition?.positionCategory)}
                </div>
            </div>
            <div className="col-12 md:col-6">
                <div className="filed-label">{translatedMessage('competition.positionGrade')}</div>
                <div className="filed-value">
                    {translatedMessage("PositionGrade." + competition?.positionGrade)}
                </div>
            </div>
            <div className="col-12">
                <div className="filed-label">{translatedMessage('competition.positionType')}</div>
                <div className="filed-value">
                    {translatedMessage("PositionType." + competition?.positionType)}
                </div>
            </div>
            <div className='col-12 md:col-6'>
                <div className='filed-label'>{translatedMessage('competition.startDate')}</div>
                <div className='filed-value'>{GeneralUtils.formatDate(competition?.startDate)}</div>
            </div>
            <div className='col-12 md:col-6'>
                <div className='filed-label'>{translatedMessage('competition.submitEndDate')}</div>
                <div className='filed-value'>{GeneralUtils.formatDate(competition?.submitEndDate)}</div>
            </div>
            <div className='col-12 md:col-6'>
                <div className='filed-label'>{translatedMessage('competition.clarificationInterval')}</div>
                <div className='filed-value'>{competition?.clarificationInterval} {translatedMessage("generic.days")}</div>
            </div>
            <div className='col-12 md:col-6'>
                <div className='filed-label'>{translatedMessage('competition.contestationInterval')}</div>
                <div className='filed-value'>{competition?.contestationInterval} {translatedMessage("generic.days")}</div>
            </div>
            <div className='col-12'>
                <div className='filed-label'>{translatedMessage('generic.description')}</div>
                <div className='filed-value'>
                    <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(competition?.description) }} />
                </div>
            </div>
        </>
    );
};

export default CompetitionNationalDetailsComponent;
